import React, { FC } from "react";

import classNames from "classnames";

import { StyledScaleBar, StyledScaleBarInner } from "./Styles";

export interface IScaleBarProps {
  /** Width prop can be string or number. */
  width: string | number;
  /** Custom classname for styling. */
  className?: string;
}

export const ScaleBar: FC<IScaleBarProps> = ({ width, className }) => {
  return (
    <StyledScaleBar className={classNames("c-scale-bar", className)}>
      <StyledScaleBarInner className="c-scale-bar__progress" $width={width} />
    </StyledScaleBar>
  );
};

ScaleBar.displayName = "ScaleBar";
